module.exports = __webpack_public_path__ + "static/media/animate-0.9ecc2044.mp4";